import React from 'react';
import { motion } from 'framer-motion';
import { KEY_FEATURES } from '../data/content';
import {
  Radio,
  Users,
  Briefcase,
  Sparkles,
  Compass,
  Infinity as InfinityIcon,
} from 'lucide-react';

const ICON_MAP = { Radio, Users, Briefcase, Sparkles, Compass, Infinity: InfinityIcon };

export default function KeyFeatures() {
  return (
    <section className="py-24 md:py-32">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="section-label">{KEY_FEATURES.eyebrow}</div>
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5">
            {KEY_FEATURES.title}
            <span className="grad-text-red">{KEY_FEATURES.titleAccent}</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 border border-line rounded-3xl overflow-hidden bg-white">
          {KEY_FEATURES.items.map((it, i) => {
            const Icon = ICON_MAP[it.icon] || Sparkles;
            const border =
              (i % 3 !== 2 ? 'lg:border-r ' : '') +
              (i < 3 ? 'lg:border-b ' : '') +
              (i % 2 !== 1 ? 'md:border-r ' : '') +
              (i < KEY_FEATURES.items.length - 2 ? 'md:border-b ' : '');
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className={`p-8 ${border} border-line`}
              >
                <div className="w-11 h-11 rounded-xl bg-red-soft flex items-center justify-center">
                  <Icon size={20} className="text-red" />
                </div>
                <div className="mt-5 font-display text-[20px]">{it.title}</div>
                <p className="mt-3 text-[14.5px] text-[color:var(--muted)] leading-relaxed">{it.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
